var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var NotificationMessage_1;
import { Global } from "js-vextensions";
import { StoreAccessor } from "mobx-firelink";
import { ignore } from "mobx-sync";
import { rootPageDefaultChilds } from "Utils/URL/URLs";
import { O } from "vwebapp-framework";
import { GetMapObject } from "./firebase/mapObjects";
import { WriteState } from "./main/write";
import { UsersState } from "./firebase/users";
import { VoiceState } from "./main/voice";
export var WeightingType;
(function (WeightingType) {
    WeightingType[WeightingType["Votes"] = 10] = "Votes";
    WeightingType[WeightingType["ReasonScore"] = 20] = "ReasonScore";
})(WeightingType || (WeightingType = {}));
let NotificationMessage = NotificationMessage_1 = class NotificationMessage {
    constructor(text) {
        this.id = ++NotificationMessage_1.lastID;
        this.text = text;
    }
};
NotificationMessage.lastID = -1;
NotificationMessage = NotificationMessage_1 = __decorate([
    Global
], NotificationMessage);
export { NotificationMessage };
export class MainState {
    constructor() {
        // [immerable] = true;
        this.page = "home";
        this.analyticsEnabled = true;
        // topLeftOpenPanel: string;
        // topRightOpenPanel: string;
        this.notificationMessages = [];
        // pages (and nav-bar panels)
        // ==========
        this.voice = new VoiceState();
        //@O database = new DatabaseState();
        this.users = new UsersState();
        this.feedback = {};
        // forum: Forum;
        this.more = {};
        this.home = {};
        this.write = new WriteState();
        this.profile = {};
    }
}
__decorate([
    O
], MainState.prototype, "page", void 0);
__decorate([
    O
], MainState.prototype, "urlExtraStr", void 0);
__decorate([
    O
], MainState.prototype, "lastDBVersion", void 0);
__decorate([
    O
], MainState.prototype, "envOverride", void 0);
__decorate([
    O
], MainState.prototype, "dbOverride", void 0);
__decorate([
    O
], MainState.prototype, "dbVersionOverride", void 0);
__decorate([
    O
], MainState.prototype, "analyticsEnabled", void 0);
__decorate([
    O, ignore
], MainState.prototype, "notificationMessages", void 0);
__decorate([
    O
], MainState.prototype, "voice", void 0);
__decorate([
    O
], MainState.prototype, "users", void 0);
__decorate([
    O
], MainState.prototype, "feedback", void 0);
__decorate([
    O
], MainState.prototype, "more", void 0);
__decorate([
    O
], MainState.prototype, "home", void 0);
__decorate([
    O
], MainState.prototype, "write", void 0);
__decorate([
    O
], MainState.prototype, "profile", void 0);
__decorate([
    O
], MainState.prototype, "topLeftOpenPanel", void 0);
__decorate([
    O
], MainState.prototype, "topRightOpenPanel", void 0);
__decorate([
    O
], MainState.prototype, "copiedMapObjectID", void 0);
__decorate([
    O
], MainState.prototype, "copiedMapObjectID_asCut", void 0);
__decorate([
    O
], MainState.prototype, "copiedSeedID", void 0);
/*export const GetOpenMapID = StoreAccessor("GetOpenMapID", s=>()=>{
    // return State("main", "openMap");
    const {page} = s.main;
    // if (page == 'home') return demoMap._key;
    if (page == "private") return s.main.private.selectedMapID;
    if (page == "public") return s.main.public.selectedMapID;
    if (page == "global") return globalMapID;
    return null;
});*/
// export type PageKey = "home" | ""
export const GetPage = StoreAccessor("GetPage", s => () => {
    return s.main.page || "home";
});
export const GetSubpage = StoreAccessor("GetSubpage", s => () => {
    const page = GetPage();
    return s.main[page].subpage || rootPageDefaultChilds[page];
});
export const GetCopiedMapObjectID = StoreAccessor("GetCopiedMapObjectID", s => () => {
    return s.main.copiedMapObjectID;
});
export const GetCopiedMapObject = StoreAccessor("GetCopiedMapObject", s => () => {
    const id = GetCopiedMapObjectID();
    if (!id)
        return null;
    return GetMapObject(id);
});
